import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilter1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"filter-1, sort"} maskId="square-filled-radius-0-stroke-1-IconFilter1"><path d="M3 3V7.68496L9 14.685V22.2385L15 19.8385V14.685L21 7.68496V3H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFilter1;
